<template>
  <div :class="classList" class="package-selector-option">
    <button
      class="select-button"
      @click="handleClickSelectButton"
    >
      <img :src="imageUrl" class="image" loading="lazy" />
      <div class="meta">
        <h4 class="name" @click="handleClickPackage">
          <u>{{ name }}</u>
          <b v-if="haveSubPack">[มี sub-pack]</b>
        </h4>
        <p class="desc">{{ desc }}</p>
        <p class="desc">{{ supported }}</p>
        <p class="desc">
          <span v-if="originalPrice" class="original-price">{{ originalPriceText }}</span>
          {{ pricePerMonth }}
        </p>
      </div>
    </button>
    <div v-if="(canRemove && (hasSelected === false || hasSelected === undefined))" class="action">
      <sc-button :icon="true" variant="clean" @click="handleClickRemoveButton">
        <img src="/static/icons/close-red.svg" />
      </sc-button>
    </div>
  </div>
</template>

<script>
import ScButton from "@/lib/components/ScButton";
import {
  formatCurrencyAndTwoDecimalsString
} from "@/lib/formatter";

export default {
  components: {
    ScButton
  },
  props: {
    id: { type: [String, Number], default: null },
    target: { type: String, default: "" },
    price: { type: Number, default: 0 },
    billingCycle: { type: Number, default: 0 },
    detail: { type: String, default: "" },
    serviceCount: { type: Number, default: 0 },
    projectCount: { type: Number, default: 0 },
    imageUrl: { type: String, default: "" },
    name: { type: String, default: "" },
    subpackages: { type: Array, default: () => [] },
    originalPrice: { type: Number, default: 0 },
    canSelect: { type: Boolean, default: false },
    canRemove: { type: Boolean, default: false },
    hasSelected: { type: Boolean, default: undefined }
  },
  computed: {
    desc() {
      if (!this.target) {
        return this.detail;
      }

      return `${this.target} — ${this.detail}`;
    },
    haveSubPack() {
      if (this.subpackages !== undefined && this.subpackages.length > 0) {
        return true;
      } 
        return false;
      
    },
    originalPriceText() {
      if (!this.originalPrice) {
        return "";
      }

      const price = formatCurrencyAndTwoDecimalsString(this.originalPrice / 100);

      return `${price} บาท`;
    },
    pricePerMonth() {
      const price = formatCurrencyAndTwoDecimalsString(this.price / 100);
      const billingCycle =
        this.billingCycle > 1
          ? ` ${  formatCurrencyAndTwoDecimalsString(this.billingCycle)  } `
          : " ";

      return `${price} บาท /${billingCycle}${this.cycleUnit}`;
    },
    cycleUnit() {
      return this.billingCycle === 0 ? "ครั้ง" : "เดือน";
    },
    supported() {
      const serviceCount = this.serviceCount.toLocaleString();
      const projectCount = this.projectCount.toLocaleString();
      return `${serviceCount} บริการ — ${projectCount} โครงการ`;
    },
    classList() {
      return { selectable: this.canSelect, "disable-content": this.hasSelected };
    },
    isDisabledClass() {
      return {

      };
    }
  },
  methods: {
    handleClickSelectButton() {
      this.$emit("select");
    },
    handleClickRemoveButton() {
      this.$emit("remove");
    },
    handleClickPackage() {
      const routeData = this.$router.resolve({name: 'PackageDetailPage', params: { id: this.id }});
      window.open(routeData.href, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
$logoSize: 60px;
$logoHeight: $logoSize * (2/3);
$padding: 10px ($space / 2);

.package-selector-option {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto;

  padding: $padding;

  font-family: "Sukhumvit Tadmai";

  > .select-button {
    cursor: default;
    user-select: text;
  }

  &.selectable {
    padding: 0;

    > .select-button {
      padding: $padding;
      cursor: pointer;
    }

    &:hover {
      background: #efefef;
    }
  }

  > .action {
    align-self: center;
  }
}

.select-button {
  display: flex;
  flex-flow: row nowrap;

  border: 0;
  padding: 0;
  outline: 0;
  min-width: 0;

  background: transparent;

  > .image {
    margin-top: 5px;

    flex: 0 0 $logoSize;
  }

  > .meta {
    padding-left: 20px;
    display: block;

    flex-grow: 1;

    &:not(:last-child) {
      padding-right: 20px;
    }
  }
}

.image {
  display: block;

  border-radius: 8px;
  width: $logoSize;
  height: $logoHeight;
}

.meta {
  min-width: 0;

  > .desc {
    overflow: hidden;
    height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.meta .name {
  margin: 0;
  font-size: 0.9rem;
}

.meta p {
  font-size: 0.8rem;
  color: #777;
}

.meta .name,
.meta p {
  text-align: left;
  line-height: 1.6;
}

.title {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;

  > .provider {
    padding-left: 15px;
  }
}

.provider {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  > .logo {
    margin-right: 8px;

    border-radius: $border-radius;
    width: 20px;
    height: 20px;
  }

  > .name {
    font-size: 0.8rem;
    color: black;
  }
}

.original-price {
  text-decoration: line-through;
}

.disable-content {
  pointer-events: none;
  opacity: 0.8;
  background-color: rgb(226, 226, 226);
  border-bottom: 1px solid #ffffff;
}
</style>

